var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "df-telephone" },
    [
      _c("DfHeader", { attrs: { error: _vm.error, text: _vm.schema.label } }),
      _vm._v(" "),
      _c("NsPhoneNumber", {
        staticClass: "df-telephone__input",
        attrs: {
          label: _vm.schema.label,
          country: _vm.localeCountry,
          hint: _vm.schema.hint,
          required: _vm.schema.required,
          "error-message": _vm.requiredErrorMessage
        },
        on: { "update:error": _vm.receiveError },
        model: {
          value: _vm.model,
          callback: function($$v) {
            _vm.model = $$v
          },
          expression: "model"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }